import React from "react";
import Button from "Components/button/Button";
import Toggle from "Components/toggle/Toggle";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import cx from "classnames";
import WarningBanner from "Components/warningBanner/WarningBanner";

export default class ServicesForm extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {};
  }

  submit(e) {
    e.preventDefault();
    this.props.setDataForm(this.props.formData);
    this.props.goToStep(5);
  }

  render() {
    const { formData, setFormFieldValue, formErrors } = this.props;
    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("domains.add.title.step4")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>domains.add.desc.step4</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="domains_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit}>
            <div className="formsFP">
              <Toggle
                className="inputFull2"
                label={t("input.label.access.pop")}
                name="pop_disabled"
                checked={formData.pop_disabled}
                errors={formErrors.pop_disabled}
                onChange={setFormFieldValue}
                reverse
              />
              <Toggle
                className="inputFull2"
                label={t("input.label.access.imap")}
                name="imap_disabled"
                checked={formData.imap_disabled}
                errors={formErrors.imap_disabled}
                onChange={setFormFieldValue}
                reverse
              />
              <Toggle
                className="inputFull2"
                label={t("input.label.access.smtp")}
                name="smtp_disabled"
                checked={formData.smtp_disabled}
                errors={formErrors.smtp_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.webmail")}
                name="webmail_disabled"
                checked={formData.webmail_disabled}
                errors={formErrors.webmail_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              {formData.plan !== "basic" && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.dav")}
                  name="dav"
                  checked={formData.dav}
                  errors={formErrors.dav}
                  onChange={setFormFieldValue}
                />
              )}

              {formData.plan === "enterprise" && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.active_sync")}
                  name="activesync"
                  checked={formData.activesync}
                  errors={formErrors.activesync}
                  onChange={setFormFieldValue}
                />
              )}

              {/*formData.plan === "enterprise" && (
              <Toggle
                className="inputFull2"
                label={t("input.label.access.chat")}
                name="chat"
                checked={formData.chat}
                errors={formErrors.chat}
                onChange={setFormFieldValue}
              />
            )*/}

              {/*formData.plan === "enterprise" && (
              <Toggle
                className="inputFull2"
                label={t("input.label.access.meeting")}
                name="meeting"
                checked={formData.meeting}
                errors={formErrors.meeting}
                onChange={setFormFieldValue}
              />
            )*/}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />{" "}
              </div>
            )}

            <div className="footerFP">
              <Button color="text" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit">
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>

      /*<div>
        <form method="post" onSubmit={this.submit}>
          <OrderStepTitle
            title={t("domain.services.title")}
            subtitle={t("domain.services.subtitle")}
            helpTooltip={
              <HelpTooltip
                children={[
                  {
                    title: t("domain.services.tooltip.title"),
                    description: t("domain.services.tooltip.description")
                  }
                ]}
              />
            }
          />
          <Column className="mt40">
            <Toggle
              inline
              label="POP"
              name="pop_disabled"
              reverse
              checked={formData.pop_disabled}
              errors={formErrors.pop_disabled}
              onChange={setFormFieldValue}
            />
          </Column>
          <Column className="mt20">
            <Toggle
              inline
              label="IMAP"
              name="imap_disabled"
              reverse
              checked={formData.imap_disabled}
              errors={formErrors.imap_disabled}
              onChange={setFormFieldValue}
            />
          </Column>
          <Column className="mt20">
            <Toggle
              inline
              label="SMTP"
              name="smtp_disabled"
              reverse
              checked={formData.smtp_disabled}
              errors={formErrors.smtp_disabled}
              onChange={setFormFieldValue}
            />
          </Column>
          <Column className="mt20">
            <Toggle
              inline
              label="Webmail"
              name="webmail_disabled"
              reverse
              checked={formData.webmail_disabled}
              errors={formErrors.webmail_disabled}
              onChange={setFormFieldValue}
            />
          </Column>
          <Column className="mv40">
            <Column base="1-2" contAlignment="left">
              <Button color="text" type="button" onClick={() => this.props.goToStep(2)}>
                button.previous
              </Button>
            </Column>
            <Column base="1-2" contAlignment="right">
              <Button>button.next</Button>
            </Column>
          </Column>
        </form>
      </div>*/
    );
  }
}
